import { Grid } from '@material-ui/core';
import Loader from 'app/components/Loader';
import { useModal } from 'app/context/Modal';
import { handelStatusError } from 'app/utils/helpers';
import { getSearchState } from 'app/utils/search-state';
import React, { FunctionComponent } from 'react';
import { useQuery } from 'react-query';
import { VideoViewCharts } from 'videos/pages/VideoView/VideoViewCharts';
import { getVideoView } from 'videos/Requests';

import styles from './VideoSingle.module.scss';

interface Props {
  isTemplate?: boolean;
}

const VideoSingle: FunctionComponent<Props> = ({ isTemplate }) => {
  const { id } = getSearchState();
  const modal = useModal();
  const { isLoading, data: currentVideo } = useQuery(
    ['getVideoView', id],
    getVideoView,
    {
      onError: (error) => {
        handelStatusError(error, modal.show);
      },
    }
  );
  if (isLoading) return <Loader />;
  return (
    <div className={styles.VideoSingle}>
      <Grid spacing={3} container>
        <VideoViewCharts
          isTemplate={isTemplate}
          videoId={id}
          currentVideo={currentVideo}
          isReport
          removeComments={isTemplate}
        />
      </Grid>
    </div>
  );
};

export default VideoSingle;
